/* HOLT — cart drawer extras.
   - add to cart from anywhere, using the theme's own drawer contract
   - close the drawer by clicking outside it, with no floating X
   Delegated from document so it survives the drawer re-rendering itself. */
(function () {
  function rootUrl() {
    return (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
  }

  function drawerEl() {
    return document.querySelector('cart-drawer');
  }

  /* Adds a variant and repaints the drawer the same way the theme's own
     product form does: ask /cart/add.js for the drawer sections in the same
     request, then hand the response straight to renderContents. */
  window.holtAddToCart = function (variantId, quantity, evt) {
    var drawer = drawerEl();
    var body = {
      items: [{ id: Number(variantId), quantity: quantity || 1 }]
    };

    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    return fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message || 'Could not add');
        if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(data, evt);
        } else if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        return data;
      });
  };

  /* Opens the drawer with fresh contents, without adding anything. */
  window.holtOpenCart = function (evt) {
    var drawer = drawerEl();
    if (!drawer || typeof drawer.renderContents !== 'function') {
      window.location.href = rootUrl() + 'cart';
      return;
    }
    var ids = drawer.getSectionsToRender().map(function (s) { return s.id; });
    fetch(rootUrl() + '?sections=' + ids.join(','), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        drawer.classList.remove('is-empty');
        drawer.renderContents({ sections: sections }, evt);
      })
      .catch(function () { drawer.open(); });
  };

  /* ---------- clicks ---------- */
  document.addEventListener('click', function (e) {
    /* close by clicking anywhere outside the drawer panel */
    var drawer = drawerEl();
    if (drawer && drawer.classList.contains('active')) {
      var inner = drawer.querySelector('.drawer__inner');
      var openedFromCartIcon = e.target.closest('#cart-icon-bubble, #cart-icon-bubble-burger');
      if (inner && !inner.contains(e.target) && !openedFromCartIcon) {
        drawer.close();
        return;
      }
    }

    /* rail scroll arrow */
    var next = e.target.closest('[data-ce-next]');
    if (next) {
      var wrap = next.closest('.holt-ce__rail-wrap');
      var rail = wrap && wrap.querySelector('[data-ce-rail]');
      if (!rail) return;
      var card = rail.querySelector('.holt-ce__card');
      var step = card ? card.getBoundingClientRect().width + 12 : rail.clientWidth * 0.8;
      rail.scrollBy({ left: step, behavior: 'smooth' });
      return;
    }

    /* open / close the frequency picker */
    var upToggle = e.target.closest('[data-holt-up-toggle]');
    if (upToggle) {
      e.preventDefault();
      var panel = upToggle.closest('[data-holt-upsell]');
      var picker = panel && panel.querySelector('[data-holt-up-picker]');
      if (!picker) return;
      var open = picker.hasAttribute('hidden');
      picker.toggleAttribute('hidden', !open);
      upToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.classList.toggle('is-open', open);
      return;
    }

    /* subscribe & save on a line item */
    var sub = e.target.closest('[data-holt-subscribe]');
    if (sub && !sub.disabled) {
      e.preventDefault();
      var label = sub.innerHTML;
      sub.disabled = true;
      sub.classList.add('is-busy');

      var payload = {
        id: sub.dataset.key,
        quantity: 0
      };
      /* remove the one-time line, then add it back on the plan */
      fetch(rootUrl() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function () {
          var body = {
            items: [{
              id: Number(sub.dataset.variant),
              quantity: Number(sub.dataset.qty) || 1,
              selling_plan: Number(sub.dataset.plan)
            }]
          };
          if (drawer && typeof drawer.getSectionsToRender === 'function') {
            body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
            body.sections_url = window.location.pathname;
          }
          return fetch(rootUrl() + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body)
          }).then(function (r) { return r.json(); });
        })
        .then(function (data) {
          if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
            drawer.renderContents(data, e);
          } else {
            window.location.reload();
          }
        })
        .catch(function () {
          sub.disabled = false;
          sub.classList.remove('is-busy');
          sub.innerHTML = label;
        });
      return;
    }

    /* rail add to cart */
    var btn = e.target.closest('[data-ce-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var id = btn.dataset.variant;
    if (!id) return;

    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    window.holtAddToCart(id, 1, e)
      .then(function () { /* drawer has repainted, this button is gone */ })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = original;
      });
  });

  /* hide the arrow once the rail is scrolled to the end */
  function syncArrows() {
    document.querySelectorAll('.holt-ce__rail-wrap').forEach(function (wrap) {
      var rail = wrap.querySelector('[data-ce-rail]');
      var next = wrap.querySelector('[data-ce-next]');
      if (!rail || !next) return;
      next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
      if (rail.dataset.bound === '1') return;
      rail.dataset.bound = '1';
      rail.addEventListener('scroll', syncArrows, { passive: true });
    });
  }

  /* the theme makes the close button chase the cursor and hides the pointer.
     Stop that so the drawer behaves like a normal panel. */
  function tameDrawer() {
    var drawer = drawerEl();
    if (!drawer || drawer.dataset.holtTamed === '1') return;
    drawer.dataset.holtTamed = '1';
    if (typeof drawer._enableDynamic === 'function') {
      drawer._enableDynamic = function () {};
      drawer._disableDynamic = function () {};
    }
    drawer.classList.remove('cursor-active');
  }

  function init() { tameDrawer(); syncArrows(); }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('cart:refresh', function () { setTimeout(init, 100); });
  if (document.readyState !== 'loading') init();
})();

/* ---------------------------------------------------------------------------
   HOLT — discount code row (ARMRA pattern)

   Collapsed row -> input on click. Delegated from document because the cart
   drawer replaces its own innerHTML on every cart change, so anything bound
   directly to these nodes would be dead after the first add-to-cart.

   Applying navigates to /discount/CODE?redirect=<current path>. That is
   Shopify's only supported way to apply a code outside checkout — there is no
   AJAX cart endpoint for it.
   ------------------------------------------------------------------------- */
(function () {
  function openField(root) {
    var toggle = root.querySelector('.holt-disc__toggle');
    var field = root.querySelector('.holt-disc__field');
    if (!field) return;
    field.hidden = false;
    if (toggle) { toggle.hidden = true; toggle.setAttribute('aria-expanded', 'true'); }
    var input = field.querySelector('.holt-disc__input');
    if (input) input.focus();
  }

  function apply(root) {
    var input = root.querySelector('.holt-disc__input');
    if (!input) return;
    var code = (input.value || '').trim();
    if (!code) { input.focus(); return; }
    root.setAttribute('data-busy', 'true');
    window.location.href =
      '/discount/' + encodeURIComponent(code) +
      '?redirect=' + encodeURIComponent(window.location.pathname + window.location.search);
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('.holt-disc__toggle');
    if (t) { openField(t.closest('[data-holt-disc]')); return; }
    var a = e.target.closest('.holt-disc__apply');
    if (a) { apply(a.closest('[data-holt-disc]')); }
  });

  // Enter submits; Escape collapses back to the row
  document.addEventListener('keydown', function (e) {
    if (!e.target.classList || !e.target.classList.contains('holt-disc__input')) return;
    var root = e.target.closest('[data-holt-disc]');
    if (e.key === 'Enter') { e.preventDefault(); apply(root); }
    if (e.key === 'Escape') {
      var field = root.querySelector('.holt-disc__field');
      var toggle = root.querySelector('.holt-disc__toggle');
      e.target.value = '';
      if (field) field.hidden = true;
      if (toggle) { toggle.hidden = false; toggle.setAttribute('aria-expanded', 'false'); }
    }
  });
})();
